<template>
  <div class="exhibitor-info">
    <div class="exhibitor-info-top">
      <div class="left">
        <img class="img" :src="exhibitorInfo.logoImage || 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/invite-default-avatar.png'" alt="">
      </div>
      <div class="right">
        <div class="right-title">{{exhibitorInfo.name}}</div>
        <div class="right-label">{{exhibitorInfo.exhibitionBoothNumber}}</div>
      </div>
    </div>

    <div class="exhibitor-attr">
      <div class="exhibitor-attr-inner">
        <div class="attr-item">
          <div class="left">
            <span class="iconfont icon-a-88show_didiandingwei"></span>
            <span class="text">所在地：</span>
          </div>
          <div class="right">{{exhibitorInfo.provinceName}} {{exhibitorInfo.cityName}}</div>
        </div>
        <div class="attr-item border-none">
          <div class="left">
            <span class="iconfont icon-a-104show_guangchang"></span>
            <span class="text">主营品类：</span>
          </div>
          <div class="right">
            <!-- 白酒 -->
          </div>
        </div>
      </div>
    </div>

    <div class="exhibitor-desc" v-if="exhibitorInfo.introduction">
      <div class="exhibitor-desc-inner">
        <div class="info-title">
          <div class="line"></div>
          <div class="text">展商介绍</div>
        </div>
        <div class="info-desc">
          <p class="info-desc-item">{{exhibitorInfo.introduction}}</p>
        </div>
      </div>
    </div>

    <div class="exhibitor-desc" v-if="productList.length" style="margin-top: 12px;">
      <div class="exhibitor-desc-inner">
        <div class="info-title">
          <div class="line"></div>
          <div class="text">主推展品</div>
        </div>
        <div class="product-content">
          <div class="product-item" v-for="item in productList" :key="item.id">
            <div class="product-img">
              <img class="img" :src="item.iconUrlImage" alt="">
            </div>
            <div class="name ellipsis-1">{{item.productName}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="operate-area">
      <div class="operate-area-inner">
        <div class="left">
          <div class="icon-item">
            <div class="iconfont icon-zhuye_weixuanzhong"></div>
            <div class="name">首页</div>
          </div>
          <div class="icon-item">
            <div class="icon-img">
              <img width="22" height="22" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/icon-service.png" alt="">
            </div>
            <div class="name service">客服</div>
          </div>
          <div class="icon-item" :class="[exhibitorInfo.collected ? 'collected' : '']" @click="onCollect">
            <div class="iconfont" :class="[exhibitorInfo.collected ? 'icon-shoucang-xuanzhong' : 'icon-shoucang']"></div>
            <div class="name">{{ exhibitorInfo.collected ?'已收藏' : '收藏'}}</div>
          </div>
        </div>
        <div class="right">
          <div class="invite-button" @click="onInvite">
            <div class="invite-msg">
              <img class="img" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/icon-invite.png" alt="">
            </div>
            <div class="button-text">预约洽谈</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters} from 'vuex'

  export default {
    data() {
      return {
        exhibitorInfo: {},
        productList: []
      }
    },
    computed: {
      ...mapGetters(['id', 'preReg'])
    },
    created() {
      this.getExhibitor()
      this.getProduct()
    },
    mounted() {
      console.log(this.id, 'ididid')
    },
    methods: {
      getExhibitor() {
        this.$http.getExhibitorDetails({ id: this.id }).then(res => {
          if (res.code === 1000) {
            this.exhibitorInfo = res.data
          }
        })
      },
      getProduct() {
        const params = {
          exhibitorId: this.id,
          showType: 'PRODUCT_LIST',
          verifyState: 'ONLINE',
          yudengji: this.preReg + '',
          pageNum: 1,
          pageRows: 6
        }
        this.$http.simpleProductList(params).then(res => {
          if (res.code === 1000) {
            this.productList = res.data.list.map(item => {
              if (item.iconUrl) {
                item.iconUrlImage = item.iconUrl.split(',') ? item.iconUrl.split(',')[0] : ''
              }
              return item
            })
            console.log(res)
          }
        })
      },
      onCollect() {
        const params = {
          id: this.exhibitorInfo.collectionId,
          collectionSubjectId: this.exhibitorInfo.id,
          collectionSubjectType: 'ACTOR',
          deleted: this.exhibitorInfo.collected
        }
        this.$http.addCollection(params).then(res => {
          if (res.code === 1000) {
            this.exhibitorInfo.collected = !this.exhibitorInfo.collected
          }
        })
      },
      onInvite() {
        wx.miniProgram.navigateTo({
          url: '/pages/inviteSend/index?id=' + this.exhibitorInfo.id
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .exhibitor-info {
    background: linear-gradient( 180deg, #FFFFFF 0%, #F5F5F5 19%);
    padding-bottom: 100px;
  }
  .exhibitor-info-top {
    display: flex;
    background: #ffffff;
    padding: 16px 12px;
    .left {
      width: 60px;
      height: 60px;
      .img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
      }
    }
    .right {
      flex: 1;
      padding-left: 12px;
      padding-top: 4px;
      .right-title {
        font-weight: 600;
        font-size: 15px;
        color: #333333;
      }
      .right-label {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        margin-top: 10px;
        word-break: break-word;
      }
    }
  }
  .exhibitor-attr {
    padding: 12px;
    .exhibitor-attr-inner {
      background: #ffffff;
      border-radius: 8px;
      padding: 0 12px;
    }
    .attr-item {
      padding: 12px 0;
      display: flex;
      align-items: baseline;
      border-bottom: 1px solid rgba(0,0,0,0.09);
      &.border-none {
        border-bottom: none;
      }
      .left {
        display: flex;
        align-items: center;
        .iconfont {
          color: #666666;
          font-size: 13px;
          margin-right: 6px;
        }
        .text {
          font-weight: 400;
          font-size: 13px;
          color: #666666;
        }
      }
      .right {
        flex: 1;
        font-weight: 400;
        font-size: 13px;
        color: #333333;
      }
    }
  }
  .exhibitor-desc {
    padding: 0 12px;
    .exhibitor-desc-inner {
      padding: 12px;
      background: #ffffff;
      border-radius: 8px;
      .info-title {
        display: flex;
        align-items: center;
        .line {
          width: 3px;
          height: 16px;
          background: #EA592A;
          margin-right: 8px;
        }
        .text {
          font-weight: 600;
          font-size: 15px;
          color: #333333;
        }
      }
      .info-desc {
        margin-top: 12px;
        .info-desc-item {
          font-weight: 400;
          font-size: 13px;
          color: #666666;
          margin: 0;
          margin-bottom: 8px;
          text-indent: 2em;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .product-content {
    margin-top: 12px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    .product-item {
      width: 100%;
      min-width: 104px;
      .product-img {
        padding-top: 100%;
        position: relative;
        .img {
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 6px;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .name {
        padding-top: 8px;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        text-align: center;
      }
    }
  }
  .operate-area {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 12px 12px 20px;
    box-sizing: border-box;
    background: #ffffff;
    .operate-area-inner {
      display: flex;
      .left {
        flex: 1;
        display: flex;
        .icon-item {
          padding: 0 12px;
          box-sizing: border-box;
          text-align: center;
          &.collected {
            .iconfont {
              color: #EA592A;
            }
            .name {
              color: #EA592A;
            }
          }
          .iconfont {
            font-size: 20px;
            color: #666666;
          }
          .icon-img {
            width: 22px;
            height: 22px;
            margin: 0 auto;
          }
          .name {
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            margin-top: 3px;
          }
        }
      }
      .right {
        width: 160px;
        display: flex;
        flex-direction: row-reverse;
        .invite-button {
          width: 100%;
          height: 40px;
          padding: 12px 0;
          box-sizing: border-box;
          display: flex;
          background: #EA592A;
          border-radius: 50px;
          align-items: center;
          justify-content: center;
          .invite-msg {
            width: 16px;
            height: 16px;
            margin-right: 7px;
            .img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .button-text {
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
          }
        }
      }
    }
  }
</style>